import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import Login from './Login'
import Dashboard from './Dashboard'
import Conversation from './Conversation'

import { AuthContext } from './Login/context'

import getParams from './utils'

import './index.scss'

const App = props => {
    const [isConversationView, setConversationView] = useState(false)
    const [conversationParams, setConversationParams] = useState(false)

    const context = useContext(AuthContext)

    const { isInit, isAuth } = context

    useEffect(() => {
        const params = getParams(props)

        // If conversation view
        if (params) {
            setConversationView(true)
            setConversationParams(params)
        }
    }, [props])

    return (
        <React.Fragment>
            {isInit && (
                <div className='App'>
                    {isConversationView ? (
                        <Conversation conversationParams={conversationParams} />
                    ) : (
                        <React.Fragment>
                            {isAuth ? <Dashboard /> : <Login />}
                        </React.Fragment>
                    )}
                </div>
            )}
        </React.Fragment>
    )
}

export default withRouter(App)
